import { useCallback, useContext } from 'react';

import { TokenContext } from '@/Contexts/TokenContext';
import { ApplicationTypes } from '@/models/ApplicationType';
import { PartnerYearsRecognized } from '@/models/PartnerYearsRecognized';
import { ProgramNames } from '@/models/Program';
import { baseUrl } from '@/utils/constants';

import { useCustomFetch } from './useCustomFetch';

export default function usePartnerYearsRecognized() {
  const { authResult } = useContext(TokenContext);
  const { customFetch } = useCustomFetch();

  const postPartnerYearsRecognized = useCallback(
    async (
      partnerId: number,
      programId: ProgramNames,
      applicationTypeId: ApplicationTypes,
      partnerYearsRecognized: PartnerYearsRecognized[]
    ): Promise<PartnerYearsRecognized[]> => {
      const fetchUrl = `${baseUrl}partners/yearsrecognized`;

      const request = {
        partnerId: partnerId,
        programId: programId,
        applicationTypeId: applicationTypeId,
        partnerYearsRecognized: partnerYearsRecognized,
      };

      const response = await customFetch<PartnerYearsRecognized[]>(fetchUrl, {
        method: 'POST',
        headers: {
          accept: 'application/json',
          'content-type': 'application/json',
          Authorization: `Bearer ${authResult.accessToken}`,
        },
        body: JSON.stringify(request),
      });

      return response;
    },
    [authResult, customFetch]
  );

  return { postPartnerYearsRecognized };
}
